<template>
  <div id="tour-page">
    <HeaderSection :relativeLinks="false"></HeaderSection>
    <main>
      <TourSection id="tour"></TourSection>
      <FooterSection></FooterSection>
    </main>
  </div>
</template>

<script>
import HeaderSection from "@/components/HeaderSection.vue";
import TourSection from "@/components/TourSection.vue";
import FooterSection from "@/components/FooterSection.vue";

export default {
  name: "TourPage",
  components: {
    HeaderSection,
    TourSection,
    FooterSection,
  },
};
</script>

<style scoped>
#tour-page {
  background-image: url("@/assets/CWHOS/CWHOS-bg-goop-nav.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  min-height: 100vh;
}

main {
  padding-top: 70px;
}

@media screen and (max-width: 768px) {
  main {
    padding-top: 0;
  }
}
</style>

